/*
 * Public API Surface of pepperi-lib/checkbox
 */
export * from './checkbox.module';
export * from './checkbox.component';
